import axiosInstance from "../../config/axiosInstance";
import { ChatQuestionHistoryResponse } from "../../types/chatQuestionHistory";

const fetchChatQuestionHistory = async (params: {
  page: number;
  limit: number;
}) => {
  const { data } = await axiosInstance.get<ChatQuestionHistoryResponse>(
    "/api/getQuestionHistory",
    {
      params,
    }
  );
  return { data, params };
};
const chatQuestionHistoryService = {
  fetchChatQuestionHistory,
};
export default chatQuestionHistoryService;
